import { render, staticRenderFns } from "./BusquedaDePedidos.vue?vue&type=template&id=9ee45ae8&scoped=true&"
import script from "./BusquedaDePedidos.vue?vue&type=script&lang=js&"
export * from "./BusquedaDePedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee45ae8",
  null
  
)

export default component.exports